import React from "react"

const ArrowClientsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
            <path d="M10.5 0.750035C10.5 0.750035 7.1858 5.24999 5.99996 5.25C4.81413 5.25001 1.5 0.75 1.5 0.75" stroke="#898989" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default ArrowClientsIcon